<template>
  <div class="k-page-content">
    <div class="mg-title-header">
      <h1>
        <i class="el-icon-arrow-left" @click="backSource"></i> 上传素材
      </h1>
    </div>
    <div class="mg-table-wrapper" style="overflow: auto;">
      <el-form
        label-width="110px"
        label-position="left"
        :size="size"
        :model="addSource"
        ref="addSource"
        :rules="rules.addSource"
      >
        <div class="extra-area">
          <div class="block-title">基本信息</div>
          <div class="block-form">
            <el-form-item label="素材专辑" prop="source_group_id">
              <el-cascader
                v-model="addSource.source_group_id"
                :options="treeData"
                :props="cascaderProps"
                clearable
                style="width:220px;"
                popper-class="sourceCas"
                :show-all-levels="false"
              ></el-cascader>
              <span
                style="margin-left: 16px; color: rgb(25, 122, 251); cursor: pointer;"
                @click="addFolderOpen"
              >新建文件夹</span>
            </el-form-item>
            <el-form-item label="创意人" prop="creativityIds">
              <el-select
                placeholder="请选择创意人"
                clearable
                v-model="addSource.creativityIds"
                style="width:220px"
              >
                <el-option
                  v-for="item in userOptions"
                  :key="item.id"
                  :label="item.nickname"
                  :value="item.id"
                ></el-option>
              </el-select>
              <div class="person_add">
                <span class="no-found">找不到人员？</span>
                <a class="add_person" v-if="info.views.isManager == 1" @click="addUserOpen">添加人员</a>
                <a class="add_person" v-if="info.views.isManager != 1" @click="addUserTips">添加人员</a>
              </div>
            </el-form-item>
            <el-form-item label="设计师" prop="designIds">
              <el-select
                clearable
                placeholder="请选择设计师"
                v-model="addSource.designIds"
                style="width:220px"
              >
                <el-option
                  v-for="item in userOptions"
                  :key="item.id"
                  :label="item.nickname"
                  :value="item.id"
                ></el-option>
              </el-select>
              <div class="person_add">
                <span class="no-found">找不到人员？</span>
                <a class="add_person" v-if="info.views.isManager == 1" @click="addUserOpen">添加人员</a>
                <a class="add_person" v-if="info.views.isManager != 1" @click="addUserTips">添加人员</a>
              </div>
            </el-form-item>
            <el-form-item label="素材备注(选填)" prop="remark">
              <el-input
                v-model="addSource.remark"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 3}"
                placeholder="请输入备注"
                style="width:340px"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="extra-area">
          <div class="block-title">
            附加信息(选填)
            <i class="el-icon-arrow-down" :class="active" @click="attachOpen"></i>
          </div>
          <div class="block-form" v-show="isShow">
            <el-form-item label="拍摄人员" prop="shootIds">
              <el-select
                clearable
                multiple
                placeholder="请选择拍摄人员"
                v-model="addSource.shootIds"
                style="width:220px"
              >
                <el-option
                  v-for="item in userOptions"
                  :key="item.id"
                  :label="item.nickname"
                  :value="item.id"
                ></el-option>
              </el-select>
              <div class="person_add">
                <span class="no-found">找不到人员？</span>
                <a class="add_person" v-if="info.views.isManager == 1" @click="addUserOpen">添加人员</a>
                <a class="add_person" v-if="info.views.isManager != 1" @click="addUserTips">添加人员</a>
              </div>
            </el-form-item>
            <el-form-item label="参演人员" prop="actorIds">
              <el-select
                clearable
                multiple
                placeholder="请选择参演人员"
                v-model="addSource.actorIds"
                style="width:220px"
              >
                <el-option
                  v-for="item in userOptions"
                  :key="item.id"
                  :label="item.nickname"
                  :value="item.id"
                ></el-option>
              </el-select>
              <div class="person_add">
                <span class="no-found">找不到人员？</span>
                <a class="add_person" v-if="info.views.isManager == 1" @click="addUserOpen">添加人员</a>
                <a class="add_person" v-if="info.views.isManager != 1" @click="addUserTips">添加人员</a>
              </div>
            </el-form-item>
            <el-form-item label="配音人员" prop="dubIds">
              <el-select
                clearable
                multiple
                placeholder="请选择配音人员"
                v-model="addSource.dubIds"
                style="width:220px"
              >
                <el-option
                  v-for="item in userOptions"
                  :key="item.id"
                  :label="item.nickname"
                  :value="item.id"
                ></el-option>
              </el-select>
              <div class="person_add">
                <span class="no-found">找不到人员？</span>
                <a class="add_person" v-if="info.views.isManager == 1" @click="addUserOpen">添加人员</a>
                <a class="add_person" v-if="info.views.isManager != 1" @click="addUserTips">添加人员</a>
              </div>
            </el-form-item>
            <el-form-item label="录屏人员" prop="screenRecordingIds">
              <el-select
                clearable
                multiple
                placeholder="请选择录屏人员"
                v-model="addSource.screenRecordingIds"
                style="width:220px"
              >
                <el-option
                  v-for="item in userOptions"
                  :key="item.id"
                  :label="item.nickname"
                  :value="item.id"
                ></el-option>
              </el-select>
              <div class="person_add">
                <span class="no-found">找不到人员？</span>
                <a class="add_person" v-if="info.views.isManager == 1" @click="addUserOpen">添加人员</a>
                <a class="add_person" v-if="info.views.isManager != 1" @click="addUserTips">添加人员</a>
              </div>
            </el-form-item>
          </div>
        </div>
        <div class="extra-area" style>
          <div class="block-title">上传区域</div>
          <div class="block-form">
            <el-form-item label="上传素材" prop="filelist">
              <el-upload
                class="upload-source"
                withCredentials
                drag
                :action="diaLog.uploadUrl"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :on-success="uploadSuccess"
                :file-list="addSource.file"
                :before-upload="detectMaterial"
                :on-exceed="LimitExceeded"
                :limit="20"
                multiple
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或
                  <em>点击上传</em>
                </div>
                <div class="el-upload__tip" slot="tip">
                  <i class="el-icon-warning" style="color: red"></i>&nbsp;&nbsp;&nbsp;图片：支持图片格式：png、jpg、jpeg、gif，不超过1.5MB;
                </div>
                <div class="el-upload__tip" slot="tip">
                  <i class="el-icon-warning" style="color: red"></i>&nbsp;&nbsp;&nbsp;视频：支持视频格式：mp4、3gp、avi、mov，不超过200MB。
                </div>
                <div class="el-upload__tip" slot="tip">
                  <i class="el-icon-warning" style="color: red"></i>&nbsp;&nbsp;&nbsp;名称：上传文件将自动生成素材名称；规则【素材类型_上传人_自定义名称_规格_随机数】
                </div>
              </el-upload>
            </el-form-item>
          </div>
        </div>
        <div class="extra-area" style="padding:24px 0 24px 45px;">
          <el-button
            type="primary"
            :size="size"
            style="width:120px;"
            @click="submitSource('addSource')"
          >完成</el-button>
        </div>
      </el-form>
    </div>

    <el-dialog
      title="提示"
      custom-class="k-dialog-tips"
      :visible.sync="userdialogVisible"
      width="30%"
    >
      <span>请联系主账户持有者添加相关人员账户</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="userdialogVisible = false" :size="size">取 消</el-button>
        <el-button type="primary" @click="userdialogVisible = false" :size="size">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="新建文件夹"
      custom-class="k-dialog--small"
      :visible.sync="addFolderVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addFolder" ref="addFolder" :rules="rules.addFolder" label-width="95px">
        <el-form-item label="名称" prop="name">
          <el-input type="text" v-model="addFolder.name" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="专辑" prop="pid">
          <el-cascader
            v-model="addFolder.pid"
            :options="treeData"
            :props="cascaderProps"
            clearable
            style="width:100%;"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="备注(非必填)" prop="remark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 3}"
            placeholder="请输入备注"
            v-model="addFolder.remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :size="size" @click="handelFolderAdd">确 定</el-button>
        <el-button @click="addFolderVisible = false" :size="size">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="diaLog.previewVisible" :close-on-click-modal="false" width="50%">
      <div class="k-dialog-preview">
        <img v-if="diaLog.type == 'image'" :src="diaLog.dialogImageUrl" alt />
        <video v-if="diaLog.type == 'video'" width="100%" height="500" controls="controls">
          <source :src="diaLog.dialogImageUrl" type="video/mp4" />
        </video>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ['info'],
  data() {
    return {
      treeData: [],
      defaultProps: {
        children: 'child',
        label: 'name'
      },
      cascaderProps: {
        checkStrictly: true,
        value: 'id',
        label: 'name',
        children: 'child'
      },
      value2: [],
      size: 'small',
      sizemini: 'mini',
      //图片上传后预览
      diaLog: {
        type: 'image',
        uploadUrl: process.env.VUE_APP_BASE_API + '/assets/upload',
        dialogImageUrl: '',
        previewVisible: false
      },
      addSource: {
        creativityIds: '',
        designIds: '',
        shootIds: [],
        actorIds: [],
        dubIds: [],
        screenRecordingIds: [],
        source_group_id: [],
        remark: '',
        filelist: []
      },
      userOptions: [],
      rules: {
        addSource: {
          source_group_id: [
            {
              type: 'array',
              required: true,
              message: '请选择素材目录',
              trigger: 'change'
            }
          ],
          creativityIds: [
            { required: true, message: '请选择创意人', trigger: 'change' }
          ],
          designIds: [
            { required: true, message: '请选择设计师', trigger: 'change' }
          ],
          filelist: [
            { required: true, message: '请选择您要上传的素材', trigger: 'blur' }
          ]
        },
        addFolder: {
          name: [
            {
              required: true,
              message: '请填写名称',
              trigger: ['change', 'blur']
            },
            {
              max: 50,
              message: '名称长度不能超过 50 个汉字或字符',
              trigger: ['change', 'blur']
            }
          ],
          pid: [
            {
              required: function() {
                if (this.addFolder.pid || this.addFolder.pid.length > 0) {
                  return false
                }
                return true
              },
              message: '请选择素材目录',
              trigger: 'change'
            }
          ]
        }
      },
      userdialogVisible: false,
      addFolderVisible: false,
      addFolder: {
        name: '',
        remark: '',
        pid: ''
      },
      loading: false,
      isShow: false,
      active: ''
    }
  },
  watch: {},
  computed: {},
  methods: {
    //小预览中删除素材
    handleRemove: function(file, fileList) {
      this.$api.assets
        .delFile({
          fileId: file.response.data.fileId
        })
        .then(res => {
          if (res.code == '0') {
            this.$message({
              message: '删除素材成功！',
              type: 'success'
            })
          } else {
            var message = '服务器数据异常！'
            if (res.message) {
              message = res.message
            }
            this.$notify({
              title: '警 告',
              message: message,
              type: 'warning'
            })
          }
        })
    },
    //小预览中大预览素材
    handlePreview: function(file) {
      this.diaLog.dialogImageUrl = file.response.data.image_url
      this.diaLog.previewVisible = true
      if (file.raw.type.indexOf('image') >= 0) {
        this.diaLog.type = 'image'
      } else if (file.raw.type.indexOf('video') >= 0) {
        this.diaLog.type = 'video'
      }
    },
    //上传成功方法
    uploadSuccess: function(response, file, fileList) {
      if (response.code == 0) {
        this.addSource.filelist.push({ fileId: response.data.fileId })
      } else {
        var index = fileList.indexOf(file)
        if (index !== -1) {
          fileList.splice(index, 1)
        }
        this.$notify({
          title: '警 告',
          message: response.message,
          type: 'warning'
        })
        return false
      }
    },
    // 上传之前的检测
    detectMaterial: function(file) {
      var arr = file.type.split('/')
      if (
        this.addSource.source_group_id.length < 1 &&
        this.addSource.creativityIds.length < 1 &&
        this.addSource.designIds.length < 1
      ) {
        this.$notify({
          title: '警 告',
          message:
            '为确保素材完成上传即保存至素材库，请先将素材相关信息补充完整。',
          type: 'warning'
        })
        return false
      } else if (arr[0] == 'video' && file.size / 1024 / 1024 > 200) {
        this.$notify({
          title: '警 告',
          message: '您上传的视频素材超过200M的限制',
          type: 'warning'
        })
        return false
      } else if (arr[0] == 'image' && file.size / 1024 / 1024 > 3) {
        this.$notify({
          title: '警 告',
          message: '您上传的图片素材超过3M的限制',
          type: 'warning'
        })
        return false
      }
    },
    LimitExceeded: function() {
      this.$notify({
        title: '警 告',
        message: '超出上传个数限制,最多上传20个',
        type: 'warning'
      })
    },
    //获取素材目录
    getTreeData() {
      this.loading = true
      this.$api.assets.getGroupTree().then(res => {
        if (res.code === 0) {
          this.treeData = res.data.res
          // this.$message({
          //     showClose: true,
          //     message: '查询应用列表信息成功！',
          //     type: 'success'
          // });
        } else {
          var message = '查询应用列表信息失败！'
          if (res.message) {
            message = res.message
          }
          this.$message({
            showClose: true,
            message: message,
            type: 'error'
          })
        }
        this.loading = false
      })
    },
    //获取附加人员
    handleUser: function() {
      this.$api.assets.getSub().then(res => {
        this.userOptions = res.data
      })
    },
    //添加人员
    addUserOpen: function() {
      this.$router.replace('/user')
    },
    //添加人员-联系主账户
    addUserTips: function() {
      this.userdialogVisible = true
    },
    //新建文件夹
    addFolderOpen: function() {
      this.addFolderVisible = true
    },
    handelFolderAdd: function() {
      this.$refs['addFolder'].validate(
        function(valid) {
          if (valid) {
            this.loading = true
            if (this.addFolder.pid.length > 0) {
              this.addFolder.pid = this.addFolder.pid[
                this.addFolder.pid.length - 1
              ]
            } else {
              this.addFolder.pid = ''
            }
            this.$api.assets.addGroup(this.addFolder).then(res => {
              if (res.code === 0) {
                this.$message({
                  showClose: true,
                  message: '文件夹添加成功！',
                  type: 'success'
                })
                this.addFolderVisible = false
                this.getTreeData()
                this.addSource.source_group_id = res.data.path
              } else {
                var message = '文件夹添加失败！'
                if (res.message) {
                  message = res.message
                }
                this.$notify({
                  showClose: true,
                  message: message,
                  type: 'warning'
                })
              }
              this.loading = false
            })
          } else {
            this.$message({
              showClose: true,
              message: '请填写正确的信息！',
              type: 'warning'
            })
          }
        }.bind(this)
      )
    },
    //提交表单
    submitSource: function(formName) {
      this.loading = true
      this.$refs[formName].validate(
        function(valid) {
          if (!valid) {
            this.loading = false
            return false
          }
          this.$api.assets.addSource(this.addSource).then(res => {
            if (res.code == '0') {
              this.$message({
                message: '素材信息保存成功！',
                type: 'success'
              })
              this.loading = false
              this.$router.replace('/source')
            } else {
              var message = '服务器数据异常！'
              if (res.body.message) {
                message = res.body.message
              }
              this.$notify({
                title: '警 告',
                message: message,
                type: 'warning'
              })
              this.loading = false
            }
          })
        }.bind(this)
      )
    },
    submitTips() {
      this.$message({
        showClose: true,
        message: '请完善相关信息',
        type: 'error'
      })
    },
    //展开附加信息
    attachOpen: function() {
      this.isShow = !this.isShow
      if (this.isShow) {
        this.active = 'is-active'
      } else {
        this.active = ''
      }
    },
    //返回素材库
    backSource: function() {
      this.$router.replace('/source?activeName=second')
    }
  },
  mounted: function() {
    this.handleUser()
    this.getTreeData()
    this.$nextTick(() => {
      this.$refs['addSource'].clearValidate()
    })
  },
  beforeRouteUpdate: function(to, from, next) {
    this.getTreeData()
    next()
  }
}
</script>